import { render, staticRenderFns } from "./DashboardListFolders.vue?vue&type=template&id=db981f48"
import script from "./DashboardListFolders.vue?vue&type=script&lang=js"
export * from "./DashboardListFolders.vue?vue&type=script&lang=js"
import style0 from "./DashboardListFolders.vue?vue&type=style&index=0&id=db981f48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports